<template>
    <div>
        <div class="container px-4 pt-5 pb-5">
            <div class="row flex-lg-row-reverse align-items-center justify-content-center g-5 pt-5">
                <div class="col-10 col-sm-8 col-lg-6">
                    <img src="../assets/images/map.gif" class="d-block mx-lg-auto img-fluid w-100" alt="world" loading="lazy">
                </div>
                <div class="col-lg-6">
                    <div class="hero-text-block">
                        <h1 class="hero-headline">
                            <span class="gradient-text"> لایوی </span>
                            <span class="hero-subtitle"> نمایش زنده جهان </span>
                        </h1>
                        <p class="lead mb-4 hero-text text-justify">
                            لایوی با پوشش کامل اخبار زنده و نمایش آن‌ها روی نقشه، تجربه‌ای بی‌نظیر از مشاهده و دنبال کردن تمام اتفاقات جهان را در یک نگاه در اختیار شما می‌گذارد.
                        </p>
                        <div class="d-grid gap-2 d-md-flex text-center hero-cta-row">
                            <a href="/map" class="hero-btn">
                                مشاهده نقشه
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                     stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M19 12H5M12 5l-7 7 7 7" />
                                </svg>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container mt-2 mb-5">
            <div class="row justify-content-center">
                <div class="col-md-5 col-lg-4 text-center my-3" data-aos="fade-down" data-aos-anchor-placement="top-bottom">
                    <div class="feature-icon fi-cyan m-auto">
                        <img src="../assets/images/pins/png/search.png" class="feature-icon-img" alt="real-time">
                    </div>
                    <h4 class="eachFeature"> بررسی لحظه‌ای </h4>
                    <p class="eachFeatureDescription text-center">
                        با لایوی، کوچک‌ترین رخدادها هم از چشم شما پنهان نمی‌ماند. همه اخبار به صورت لحظه‌ای و دقیق در دسترس شما هستند.
                    </p>
                </div>
                <div class="col-md-5 col-lg-4 text-center my-3" data-aos="fade-down" data-aos-anchor-placement="top-bottom">
                    <div class="feature-icon fi-blue m-auto">
                        <img src="../assets/images/pins/png/guide.png" class="feature-icon-img" alt="tech">
                    </div>
                    <h4 class="eachFeature"> فناوری پیشرفته </h4>
                    <p class="eachFeatureDescription text-center">
                        استفاده از آخرین تکنولوژی‌ها، امنیت و کیفیت بالای ارائه محتوا را در لایوی تضمین می‌کند.
                    </p>
                </div>
                <div class="col-md-5 col-lg-4 text-center my-3" data-aos="fade-down" data-aos-anchor-placement="top-bottom">
                    <div class="feature-icon fi-purple m-auto">
                        <img src="../assets/images/pins/png/track.png" class="feature-icon-img" alt="data">
                    </div>
                    <h4 class="eachFeature"> داده‌کاوی هوشمند </h4>
                    <p class="eachFeatureDescription text-center">
                        همه اطلاعات لایوی با کمک هوش مصنوعی پردازش می‌شوند تا دقیق‌ترین اخبار در دسترس شما قرار گیرد.
                    </p>
                </div>
            </div>
        </div>

        <div class="container">
            <div class="row my-5 h-100" data-aos="fade-down" data-aos-anchor-placement="top-bottom">
                <div class="col-md-7 my-auto">
                    <div class="showcase-text">
                        <div class="showcase-tag">نقشه زنده</div>
                        <h3 class="showcase-title">
                            نمایش زنده بر روی <span class="gradient-text">نقشه</span>
                        </h3>
                        <p class="showcase-desc">
                            هر خبر با جزئیات کامل و توضیحات منحصربه‌فرد روی نقطه دقیق مرتبط به آن بر روی نقشه ارائه می‌شود تا تجربه‌ای متفاوت و جذاب از دنبال کردن رویدادهای جهانی داشته باشید.
                        </p>
                        <ul class="showcase-list">
                            <li><span class="check-icon">✓</span> موقعیت‌یابی دقیق اخبار </li>
                            <li><span class="check-icon">✓</span> جزئیات کامل هر رویداد </li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-5">
                    <div class="showcase-visual">
                        <img src="../assets/images/world.png" class="img-fluid rounded" alt="map">
                        <div class="showcase-visual-inner">
                            <div class="map-tooltip map-tooltip-1"> 📍 3 خبر جدید در آمریکا </div>
                            <div class="map-tooltip map-tooltip-2"> 📍 5 خبر فوری در تهران </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row my-5 h-100" data-aos="fade-down" data-aos-anchor-placement="top-bottom">
                <div class="col-md-7 order-md-2 my-auto">
                    <div class="showcase-text">
                        <div class="showcase-tag">شبکه‌های اجتماعی</div>
                        <h3 class="showcase-title">
                            پوشش مطالب در
                            <span class="gradient-text">شبکه‌های اجتماعی</span>
                        </h3>
                        <p class="showcase-desc">
                            پوشش کامل تمامی مطالب در شبکه‌های اجتماعی و ارتباط با مخاطبین از اولویت‌های اصلی لایوی است.
                        </p>
                        <ul class="showcase-list">
                            <li><span class="check-icon">✓</span> رصد همه پلتفرم‌ها</li>
                            <li><span class="check-icon">✓</span> اشتراک‌گذاری سریع</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-5 order-md-1">
                    <div class="showcase-visual">
                        <div class="showcase-visual-inner">
                            <div class="social-mockup">
                                <img src="../assets/images/social.png" class="img-fluid rounded" alt="map">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="container text-center pb-5">
            <div class="cta-inner" data-aos="fade-up">
                <h2 class="cta-title">
                    آماده‌اید جهان را به صورت
                    <span class="gradient-text"> زنده </span>
                    تماشا کنید؟
                </h2>
                <p class="cta-desc">
                    همین حالا به نقشه لایوی سر بزنید و تمام رویدادهای جهان را در یک
                    نگاه دنبال کنید.
                </p>
                <a href="/map" class="btn btn-primary btn-lg hero-btn">
                    مشاهده نقشه
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import AOS from 'aos'
    import { buildMeta } from "@/utils/seo";

    export default {
        name: "Index",
        metaInfo() {
            return buildMeta({
                title: "لایوی - نمایش زنده جهان",
                description: "لایوی با پوشش جامع اخبار زنده و نمایش لحظه‌ای روی نقشه، تجربه‌ای منحصربه‌فرد از دیدن و دنبال‌کردن رویدادهای جهان را در یک نگاه به شما می‌دهد.",
                path: "/",
                type: "website",
            });
        },
        components: {},
        data() {
            return {}
        },
        created() {
            AOS.init({
                once: true
            })
        },
        mounted() {
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import '~aos/dist/aos.css';
    @import "@/assets/css/tokens";

    .hero-text-block {
        text-align: right;
    }

    .hero-headline {
        font-size: clamp(2.4rem, 6vw, 3.6rem);
        font-weight: 900;
        line-height: 1.3;
        margin: 0.6rem 0 1rem;
    }

    .hero-subtitle {
        display: block;
        margin-top: 0.4rem;
        font-size: clamp(1rem, 2.4vw, 1.3rem);
        font-weight: 600;
        line-height: 1;
        background: linear-gradient(to right, #1198d0 0%, #402b67 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
    }

    .hero-text {
        color: $text-secondary;
        font-size: 16px;
        line-height: 2.1;
    }

    .hero-cta-row {
        margin-top: 0.6rem;
    }

    .feature-icon {
        width: 70px;
        height: 70px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.5rem;
    }

    .feature-icon-img {
        width: 40px;
        height: 40px;
        object-fit: contain;
    }

    .fi-cyan {
        background: rgba($accent-cyan, 0.1);
    }

    .fi-blue {
        background: rgba($accent-blue, 0.1);
    }

    .fi-purple {
        background: rgba($accent-purple, 0.1);
    }

    .eachFeature {
        margin-top: 15px;
        font-size: 1.15rem;
        font-weight: 700;
        margin-bottom: 0.75rem;
        color: $text-primary;
    }

    .eachFeatureDescription {
        font-size: 0.9rem;
        color: $text-secondary;
        line-height: 1.9;
    }

    .hero-btn {
        @include pill-button;
    }

    .bg-light {
        background-color: #f9fafb !important;
    }

    .showcase-visual {
        position: relative;
        border-radius: 24px;
        overflow: hidden;
        aspect-ratio: 4/3;
    }

    .showcase-visual-inner {
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .map-tooltip {
        position: absolute;
        background: rgba(white, 0.95);
        border: 1px solid rgba($accent-cyan, 0.2);
        border-radius: 10px;
        padding: 0.6rem 0.9rem;
        font-size: 0.7rem;
        color: $text-primary;
        white-space: nowrap;
        animation: tooltipFloat 4s ease-in-out infinite;
    }

    @keyframes tooltipFloat {
        0%,
        100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-6px);
        }
    }

    .map-tooltip-1 {
        top: 30%;
        left: 0;
    }

    .map-tooltip-2 {
        top: 45%;
        left: 50%;
        animation-delay: -2s;
    }

    .showcase-tag {
        font-size: 0.75rem;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 2px;
        color: $accent-cyan;
        margin-bottom: 0.8rem;
    }

    .showcase-title {
        font-size: clamp(1.6rem, 3vw, 2.2rem);
        font-weight: 800;
        line-height: 1.3;
        margin-bottom: 1.2rem;
    }

    .showcase-desc {
        font-size: 1rem;
        color: $text-secondary;
        line-height: 2;
        margin-bottom: 1rem;
    }

    .showcase-list {
        list-style: none;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: 0.8rem;
        li {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            font-size: 0.9rem;
            color: $text-secondary;
        }
    }

    .check-icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background: rgba($accent-cyan, 0.1);
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        color: $accent-cyan;
        font-size: 0.8rem;
    }

    .cta-inner {
        position: relative;
        margin: 0 auto;
    }

    .cta-title {
        font-size: clamp(1.8rem, 3.5vw, 2.5rem);
        font-weight: 900;
        margin-bottom: 1.2rem;
    }

    .cta-desc {
        font-size: 1.05rem;
        color: $text-secondary;
        line-height: 1.9;
        margin-bottom: 1.5rem;
    }
</style>
